// extracted by mini-css-extract-plugin
export default {"dialog_content":"AddVatPercentage_dialog_content__itkpd","dialog_actions":"AddVatPercentage_dialog_actions__02vtS"};